/* global App */
const BaseRouter = require('./base')
const views = require('./views')

module.exports = BaseRouter.extend({
    routings: null,

    initialize () {
        // NOTE: Routes added later may override previously declared routes.
        this.routings = []

        // User
        this.routings.push({
            key: 'accountUnsubscribe',
            path: new RegExp(`${App.urlRegexTo('user/account/unsubscribe-from-commercials')}.*$`),
            view: views.AccountCounterView,
        })

        // Ser ticket
        this.routings.push({
            key: 'serTicketShow',
            path: new RegExp(`${App.urlRegexTo('ser-ticket/show')}.*$`),
            view: views.SerTicketShowView,
        })

        this.routings.push({
            key: 'serTicketShow',
            path: new RegExp(`${App.urlRegexTo('ser-ticket/new')}.*$`),
            view: views.SerTicketShowView,
        })

        this.routings.push({
            key: 'serTicketShow',
            path: new RegExp(`${App.urlRegexTo('ser-ticket/pay')}.*$`),
            view: views.SerTicketPayView,
        })

        this.routings.push({
            key: 'serTicketUnpark',
            path: new RegExp(`${App.urlRegexTo('ser-ticket/unpark')}.*$`),
            view: views.SerTicketUnparkView,
        })


        // Landing Merchant how it works
        this.routings.push({
            key: 'landingMerchantHowItWorks',
            path: new RegExp(`${App.urlRegexTo('site/landing-merchant-how-it-works')}.*$`),
            view: views.LandingMerchantHowItWorksView,
        })

        // Orders
        this.routings.push({
            key: 'orderList',
            path: new RegExp(`${App.urlRegexTo('order/list')}.*$`),
            view: views.OrderListView,
        })

        this.routings.push({ key: 'invoiceList', path: new RegExp(`${App.urlRegexTo('invoice/list')}.*$`), view: views.EmptyView })

        this.generateRoutes()
    }
})
